export default __webpack_public_path__ + "static/media/laconic_medium@2x.abf19fa0.jpg";